//  * ! FIXME: Routing redirects
//  */
// const Initializer = (
//   props: CustomRouteComponentProps<{token: string}>
// ): ReactElement => {
//   // const location = useLocation();
//   // const history = useHistory();
//   // const {history, match} = props;
//   // const
//   // const token: string = location?.pathname?.split('/').slice(-1)[0];

//   // console.log('location', location);

//   // useEffect(() => {
//   //   const url =
//   //     location?.pathname + '/' + NavRoutes.PUBLIC.APPOINTMENT_PORTAL.LOGIN;
//   //   console.log('url', url);
//   //   history.push(url);
//   // }, []);
//   return <div>Initializer</div>;
//   // return <AppointmentLogin {...props} />;
// };

// export default Initializer;
import {RouteComponentProps} from 'react-router-dom';
import AppLoader from '@components/framework/apploader/AppLoader';
import React from 'react';
import {verifyGuarantorCodeToken} from '@shared/services/Payment.service';
import NavRoutes from 'src/constants/route/NavRoutes';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSnackbar} from 'notistack';
import {GuarantorPortalsTypesMap} from '@shared/constants/Mapping';

const Intializer = (
  props: RouteComponentProps<{code: string; practiceShortCode: string}>
): React.ReactElement => {
  const {enqueueSnackbar} = useSnackbar();

  const {history, match} = props;

  const loginRedirect = React.useCallback(
    (token: string): void => {
      history.push(
        `/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.BASE}/${token}/${NavRoutes.PUBLIC.APPOINTMENT_PORTAL.LOGIN}`
      );
    },
    [history]
  );

  const errorRedirect = React.useCallback(
    (errorMessage?: string): void => {
      history.push(`/${NavRoutes.PUBLIC.ERROR_PAY}`, {errorMessage});
    },
    [history]
  );

  React.useEffect(() => {
    if (match.params.code) {
      verifyGuarantorCodeToken(
        match.params.code,
        // Need to update AppointmentPortal Type
        GuarantorPortalsTypesMap.GUARANTOR,
        {is_appointment_portal: true}
      )
        .then(res => {
          if (res?.data?.token) {
            loginRedirect(res.data.token);
          }
        })
        .catch(err => {
          if (err.message) {
            enqueueSnackbar(err.message, SnackBarConfig('e'));
          }
          errorRedirect(err?.message);
        });
    } else if (match.params.practiceShortCode) {
      verifyGuarantorCodeToken(
        match.params.practiceShortCode,
        GuarantorPortalsTypesMap.PRACTICE,
        {is_appointment_portal: true}
      )
        .then(res => {
          if (res?.data?.token) {
            loginRedirect(res.data.token);
          }
        })
        .catch(err => {
          if (err.message) {
            enqueueSnackbar(err.message, SnackBarConfig('e'));
          }
          errorRedirect(err?.message);
        });
    }
  }, [
    loginRedirect,
    errorRedirect,
    match.params.code,
    match.params.practiceShortCode,
    enqueueSnackbar
  ]);

  return <AppLoader />;
};

export default Intializer;
